<template>
    <div class="page-table haberTanim mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.sayfa.guncelleme.pageBaslik")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="sayfaForm" :rules="rulesSayfalar" ref="sayfaForm" class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.baslik")'
                                                      prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             :href="this.path">
                                                        {{this.path}}{{this.sayfaForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true;  duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">{{this.path}}</span>
                                                <el-input v-if="VisibleA" v-model="sayfaForm.link"
                                                          v-on:change="$store.commit('changeTabsClose', false); linkChange = false"
                                                          v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                          style="width: 50%" size="mini"></el-input>
                                            </div>
                                            <el-input
                                                    v-model="sayfaForm.baslik"
                                                    v-on:change="linkTespit(); $store.commit('changeTabsClose', false);"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="sayfaForm.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="sayfaForm.icerik"
                                                      @input="seoIcerikTespit(); $store.commit('changeTabsClose', false)"
                                                      @blur="seoIcerikTespit(); $store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                        <el-form-item>
                                            <el-checkbox v-model="checked">Sayfa'da Buton Olsun Mu?</el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                        <el-form-item>
                                            <el-checkbox v-model="checked2" v-on:change="videoAktif">Video Olsun Mu?</el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-row :gutter="10">
                                    <el-col v-if="checked" :lg="12" :md="12" :sm="24" :xs="24">
                                        <el-collapse-item v-if="checked" class=" animated fadeInDown card-shadow--medium" title='Buton Ayarları'
                                                          name="3">
                                            <el-row>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                                  prop="butonLink">:
                                                        <el-input
                                                                v-model="sayfaForm.butonLink"
                                                                :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                                  prop="buton">:
                                                        <el-input
                                                                v-model="sayfaForm.buton"
                                                                placeholder='Buton Adı Giriniz'></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </el-collapse-item>
                                    </el-col>
                                    <el-col v-if="checked2" style="float: right" :lg="12" :md="12" :sm="24" :xs="24">
                                        <el-collapse-item class=" animated fadeInDown card-shadow--medium" title='Video'
                                                          name="3">
                                            <el-row>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <div v-for="(item,index) in sayfaForm.video" :key="index"
                                                         class="animated fadeInLeft">
                                                        <el-row class="mt-0">
                                                            <el-col :span="24">
                                                                <el-col :lg="21" :md="21" :sm="21" :xs="21">
                                                                    <el-form-item label='URL :' prop="link">
                                                                        <el-input
                                                                                v-model="sayfaForm.video[index]"
                                                                                placeholder='Video URL Giriniz'>
                                                                        </el-input>
                                                                    </el-form-item>
                                                                </el-col>
                                                                <el-col :lg="3" :md="3" :sm="3" :xs="3" class="colAyariFth">
                                                                    <el-button v-if="index+1 === sayfaForm.video.length" type="primary"
                                                                               size="mini"
                                                                               icon="el-icon-plus" v-on:click="videoEkle(sayfaForm.video[index],index)">
                                                                    </el-button>

                                                                    <el-button v-else class="deleteButton" type="danger"
                                                                               size="mini"
                                                                               icon="el-icon-close" v-on:click="removeVideo(index)"></el-button>

                                                                </el-col>

                                                            </el-col>
                                                        </el-row>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-collapse-item>
                                    </el-col>
                                </el-row>
                            </el-collapse>
                            <el-collapse class="animated fadeInUp" style="margin-top: 10px" v-model="activeCollapse">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="7">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim") + " (800x600)"'
                                                              prop="resim">:
                                                    <el-upload
                                                            class="resimler"
                                                            action=""
                                                            list-type="picture-card"
                                                            multiple
                                                            :file-list="imageListMain"
                                                            :auto-upload="false"
                                                            accept=".jpg,.jpeg,.png"
                                                            :on-change="imageUpload"
                                                            :on-preview="firstImage"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                               v-on:click="serverImageList"
                                                               @click="dialogImgServerVisible = true; " size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="Belge Ayarları" name="8">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.haberler.tanimlama.belge")'
                                                              prop="belge">:
                                                    <el-row>
                                                        <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                                            <el-upload
                                                                    multiple
                                                                    class="upload-demo"
                                                                    action=""
                                                                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                                                                    :file-list="fileListMain"
                                                                    :auto-upload="false"
                                                                    :on-change="fileUpload"
                                                                    :on-remove="fileRemove">
                                                                <el-button size="mini" style="width: 150px;"
                                                                           type="success">
                                                                    Dosya
                                                                    Yükle
                                                                </el-button>
                                                            </el-upload>
                                                            <el-button style="margin-top: 15px;width: 150px;"
                                                                       type="primary"
                                                                       v-on:click="serverDocumentList"
                                                                       @click="dialogDocServerVisible = true; "
                                                                       size="mini">
                                                                Sunucudan
                                                                Seç
                                                            </el-button>
                                                        </el-col>
                                                    </el-row>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="9">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                              prop="seoBaslik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              id="seoBaslik"
                                                              v-model="sayfaForm.seoBaslik"
                                                              @input="seoBaslikChange('seoBaslik')"
                                                              :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'>
                                                        <template slot="append">{{seoBaslikLimit}}</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                              prop="seoIcerik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              type="textarea"
                                                              v-on:focus="seoIcerikChange = false"
                                                              v-model="sayfaForm.seoIcerik">
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-de"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.de.baslik")'
                                                      prop="dil.de.baslik">:
                                            <el-input
                                                    v-model="sayfaForm.dil.de.baslik"
                                                    v-on:change="$store.commit('changeTabsClose', false); sayfaForm.dil.de.seoBaslik = sayfaForm.dil.de.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.de.altBaslik")'
                                                      prop="dil.de.altBaslik">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="sayfaForm.dil.de.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.de.icerik")'
                                                      prop="dil.de.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="sayfaForm.dil.de.icerik"
                                                      @input="seoIcerikDETespit(); $store.commit('changeTabsClose', false)"
                                                      @blur="seoIcerikDETespit(); $store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                        <el-form-item>
                                            <el-checkbox v-model="checked">Sayfa'da Buton Olsun Mu?</el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                        <el-form-item>
                                            <el-checkbox v-model="checked2" v-on:change="videoAktif">Video Olsun Mu?</el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-row :gutter="10">
                                    <el-col v-if="checked" :lg="12" :md="12" :sm="24" :xs="24">
                                        <el-collapse-item v-if="checked" class=" animated fadeInDown card-shadow--medium" title='Buton Ayarları'
                                                          name="3">
                                            <el-row>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                                  prop="butonLink">:
                                                        <el-input
                                                                v-model="sayfaForm.dil.de.butonLink"
                                                                :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                                  prop="buton">:
                                                        <el-input
                                                                v-model="sayfaForm.dil.de.buton"
                                                                placeholder='Buton Adı Giriniz'></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </el-collapse-item>
                                    </el-col>
                                    <el-col v-if="checked2" style="float: right" :lg="12" :md="12" :sm="24" :xs="24">
                                        <el-collapse-item class=" animated fadeInDown card-shadow--medium" title='Video'
                                                          name="3">
                                            <el-row>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <div v-for="(item,index) in sayfaForm.video" :key="index"
                                                         class="animated fadeInLeft">
                                                        <el-row class="mt-0">
                                                            <el-col :span="24">
                                                                <el-col :lg="21" :md="21" :sm="21" :xs="21">
                                                                    <el-form-item label='URL :' prop="link">
                                                                        <el-input
                                                                                v-model="sayfaForm.video[index]"
                                                                                placeholder='Video URL Giriniz'>
                                                                        </el-input>
                                                                    </el-form-item>
                                                                </el-col>
                                                                <el-col :lg="3" :md="3" :sm="3" :xs="3" class="colAyariFth">
                                                                    <el-button v-if="index+1 === sayfaForm.video.length" type="primary"
                                                                               size="mini"
                                                                               icon="el-icon-plus" v-on:click="videoEkle(sayfaForm.video[index],index)">
                                                                    </el-button>

                                                                    <el-button v-else class="deleteButton" type="danger"
                                                                               size="mini"
                                                                               icon="el-icon-close" v-on:click="removeVideo(index)"></el-button>

                                                                </el-col>

                                                            </el-col>
                                                        </el-row>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-collapse-item>
                                    </el-col>
                                </el-row>
                            </el-collapse>
                            <el-collapse class="animated fadeInUp" style="margin-top: 10px" v-model="activeCollapse">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="7">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                              prop="resim">:
                                                    <el-upload
                                                            class="resimler"
                                                            action=""
                                                            list-type="picture-card"
                                                            multiple
                                                            :file-list="imageListMain"
                                                            :auto-upload="false"
                                                            accept=".jpg,.jpeg,.png"
                                                            :on-change="imageUpload"
                                                            :on-preview="firstImage"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                               v-on:click="serverImageList"
                                                               @click="dialogImgServerVisible = true; " size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="Belge Ayarları" name="8">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.haberler.tanimlama.belge")'
                                                              prop="belge">:
                                                    <el-row>
                                                        <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                                            <el-upload
                                                                    multiple
                                                                    class="upload-demo"
                                                                    action=""
                                                                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                                                                    :file-list="fileListMain"
                                                                    :auto-upload="false"
                                                                    :on-change="fileUpload"
                                                                    :on-remove="fileRemove">
                                                                <el-button size="mini" style="width: 150px;"
                                                                           type="success">
                                                                    Dosya
                                                                    Yükle
                                                                </el-button>
                                                            </el-upload>
                                                            <el-button style="margin-top: 15px;width: 150px;"
                                                                       type="primary"
                                                                       v-on:click="serverDocumentList"
                                                                       @click="dialogDocServerVisible = true; "
                                                                       size="mini">
                                                                Sunucudan
                                                                Seç
                                                            </el-button>
                                                        </el-col>
                                                    </el-row>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="9">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                              prop="seoBaslik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              v-model="sayfaForm.dil.de.seoBaslik"
                                                              @input="seoBaslikChange('seoBaslik')"
                                                              :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'>
                                                        <template slot="append">{{seoBaslikLimit}}</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                              prop="seoIcerik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              type="textarea"
                                                              v-on:focus="seoIcerikDEChange = false"
                                                              v-model="sayfaForm.dil.de.seoIcerik">
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                                      prop="dil.en.baslik">:
                                            <el-input
                                                    v-model="sayfaForm.dil.en.baslik"
                                                    v-on:change="$store.commit('changeTabsClose', false); sayfaForm.dil.en.seoBaslik = sayfaForm.dil.en.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.altBaslik")'
                                                      prop="dil.en.altBaslik">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="sayfaForm.dil.en.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.icerik")'
                                                      prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="sayfaForm.dil.en.icerik"
                                                      @input="seoIcerikENTespit(); $store.commit('changeTabsClose', false)"
                                                      @blur="seoIcerikENTespit(); $store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                        <el-form-item>
                                            <el-checkbox v-model="checked">Sayfa'da Buton Olsun Mu?</el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                        <el-form-item>
                                            <el-checkbox v-model="checked2" v-on:change="videoAktif">Video Olsun Mu?</el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-row :gutter="10">
                                    <el-col v-if="checked" :lg="12" :md="12" :sm="24" :xs="24">
                                        <el-collapse-item v-if="checked" class=" animated fadeInDown card-shadow--medium" title='Buton Ayarları'
                                                          name="3">
                                            <el-row>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <el-form-item :label='$t("src.views.apps.slider.tanimlama.link")'
                                                                  prop="butonLink">:
                                                        <el-input
                                                                v-model="sayfaForm.dil.en.butonLink"
                                                                :placeholder='$t("src.views.apps.slider.tanimlama.linkPlace")'></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <el-form-item :label='$t("src.views.apps.slider.tanimlama.linkName")'
                                                                  prop="buton">:
                                                        <el-input
                                                                v-model="sayfaForm.dil.en.buton"
                                                                placeholder='Buton Adı Giriniz'></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </el-collapse-item>
                                    </el-col>
                                    <el-col v-if="checked2" style="float: right" :lg="12" :md="12" :sm="24" :xs="24">
                                        <el-collapse-item class=" animated fadeInDown card-shadow--medium" title='Video'
                                                          name="3">
                                            <el-row>
                                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                    <div v-for="(item,index) in sayfaForm.video" :key="index"
                                                         class="animated fadeInLeft">
                                                        <el-row class="mt-0">
                                                            <el-col :span="24">
                                                                <el-col :lg="21" :md="21" :sm="21" :xs="21">
                                                                    <el-form-item label='URL :' prop="link">
                                                                        <el-input
                                                                                v-model="sayfaForm.video[index]"
                                                                                placeholder='Video URL Giriniz'>
                                                                        </el-input>
                                                                    </el-form-item>
                                                                </el-col>
                                                                <el-col :lg="3" :md="3" :sm="3" :xs="3" class="colAyariFth">
                                                                    <el-button v-if="index+1 === sayfaForm.video.length" type="primary"
                                                                               size="mini"
                                                                               icon="el-icon-plus" v-on:click="videoEkle(sayfaForm.video[index],index)">
                                                                    </el-button>

                                                                    <el-button v-else class="deleteButton" type="danger"
                                                                               size="mini"
                                                                               icon="el-icon-close" v-on:click="removeVideo(index)"></el-button>

                                                                </el-col>

                                                            </el-col>
                                                        </el-row>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-collapse-item>
                                    </el-col>
                                </el-row>
                            </el-collapse>
                            <el-collapse class="animated fadeInUp" style="margin-top: 10px" v-model="activeCollapse">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="7">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                              prop="resim">:
                                                    <el-upload
                                                            class="resimler"
                                                            action=""
                                                            list-type="picture-card"
                                                            multiple
                                                            :file-list="imageListMain"
                                                            :auto-upload="false"
                                                            accept=".jpg,.jpeg,.png"
                                                            :on-change="imageUpload"
                                                            :on-preview="firstImage"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                               v-on:click="serverImageList"
                                                               @click="dialogImgServerVisible = true; " size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="Belge Ayarları" name="8">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.haberler.tanimlama.belge")'
                                                              prop="belge">:
                                                    <el-row>
                                                        <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                                            <el-upload
                                                                    multiple
                                                                    class="upload-demo"
                                                                    action=""
                                                                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                                                                    :file-list="fileListMain"
                                                                    :auto-upload="false"
                                                                    :on-change="fileUpload"
                                                                    :on-remove="fileRemove">
                                                                <el-button size="mini" style="width: 150px;"
                                                                           type="success">
                                                                    Dosya
                                                                    Yükle
                                                                </el-button>
                                                            </el-upload>
                                                            <el-button style="margin-top: 15px;width: 150px;"
                                                                       type="primary"
                                                                       v-on:click="serverDocumentList"
                                                                       @click="dialogDocServerVisible = true; "
                                                                       size="mini">
                                                                Sunucudan
                                                                Seç
                                                            </el-button>
                                                        </el-col>
                                                    </el-row>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="9">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                              prop="seoBaslik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              v-model="sayfaForm.dil.en.seoBaslik"
                                                              @input="seoBaslikChange('seoBaslik')"
                                                              :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'>
                                                        <template slot="append">{{seoBaslikLimit}}</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                              prop="seoIcerik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              type="textarea"
                                                              v-on:focus="seoIcerikENChange = false"
                                                              v-model="sayfaForm.dil.en.seoIcerik">
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-collapse>
                        </el-tab-pane>

                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.sayfa.tanimlama.durum")'>
                            <el-row>
                                <div>
                                    <el-button size="mini" class="onayBtn"
                                               v-on:click="sayfaGuncelle('sayfaForm')"
                                               type="primary">
                                        {{$t('src.views.apps.sayfa.guncelleme.sayfaguncelle')}}
                                    </el-button>
                                </div>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.sayfatipi")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.sayfatipi")'
                                                      prop="sayfaTuru">:
                                            <el-select
                                                    v-model="sayfaForm.sayfaTuru"
                                                    v-on:change="getTreeList"
                                                    style="width: 100%">
                                                <el-option value="0" label="Sayfa">Sayfa</el-option>
                                                <el-option value="1" label="Altsayfa">Altsayfa</el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                v-if="sayfaForm.sayfaTuru === '1'"
                                                :label='$t("src.views.apps.sayfa.tanimlama.sayfaturu")'
                                                prop="sayfaId ">:
                                            <el-tree
                                                    class="baskaTree"
                                                    :data="treeList"
                                                    @check="handleNodeClick"
                                                    node-key="id"
                                                    :default-checked-keys="checkedKeys"
                                                    ref="tree"
                                                    check-strictly
                                                    icon-class
                                                    show-checkbox
                                                    :props="defaultProps">
                                            </el-tree>


                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.sayfaTuruAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item class="margin-top-10">
                                            <el-button size="mini" type="success" v-on:click="iconListDialog = true"
                                                       icon="el-icon-search">İcon Seç
                                            </el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.gorunum")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.gorunum")'
                                                      prop="goster">:
                                            <el-switch
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="sayfaForm.goster"
                                                    active-value="1"
                                                    inactive-value="0"
                                                    active-text="Göster"
                                                    inactive-text="Gösterme">
                                            </el-switch>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.menuAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.resimKonum")' name="4">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="resimKonum">
                                            <el-button type="primary" size="mini" @click="drawerResimKonum = true">
                                                {{this.btnResim}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="sayfaForm.resimKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="50%" height="50%">
                                            <img v-if="sayfaForm.resimKonum === '1'" style="float: right"
                                                 src="../../../assets/images/2.png" width="50%" height="50%">
                                            <img v-if="sayfaForm.resimKonum === '2'" style="float: right"
                                                 src="../../../assets/images/5.png" width="50%" height="50%">
                                            <img v-if="sayfaForm.resimKonum === '3'" style="float: right"
                                                 src="../../../assets/images/4.png" width="50%" height="50%">
                                            <img v-if="sayfaForm.resimKonum === '4'" style="float: right"
                                                 src="../../../assets/images/3.png" width="50%" height="50%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.resimKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.menuKonum")' name="5">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="menuKonum">
                                            <el-button type="primary" size="mini" @click="drawerMenuKonum = true">
                                                {{this.btnMenu}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="sayfaForm.menuKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="50%" height="50%">
                                            <img v-if="sayfaForm.menuKonum === '1'" style="float: right"
                                                 src="../../../assets/images/6.png" width="50%" height="50%">
                                            <img v-if="sayfaForm.menuKonum === '2'" style="float: right"
                                                 src="../../../assets/images/9.png" width="50%" height="50%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.menuKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.galeriKonum")' name="6">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="galeriKonum">
                                            <el-button type="primary" size="mini" @click="drawerGaleriKonum = true">
                                                {{this.btnGaleri}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="sayfaForm.galeri === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="50%" height="50%">
                                            <img v-if="sayfaForm.galeri === '1'" style="float: right"
                                                 src="../../../assets/images/7.png" width="50%" height="50%">
                                            <img v-if="sayfaForm.galeri === '2'" style="float: right"
                                                 src="../../../assets/images/8.png" width="50%" height="50%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.galeriKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogImgServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        accept=".jpg,.jpeg,.png"
                        :on-change="serverImageUpload"
                        list-type="picture-card"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                <i class="el-icon-plus"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-dialog>
            <el-dialog
                    title='Sunucudan Belge Seç'
                    :visible.sync="dialogDocServerVisible"
                    width="50%"
                    center>
                <el-upload
                        action="#"
                        accept=".pdf,.doc,.docx,.xls,.xlsx"
                        class="upload-demo"
                        :on-preview="fileUploadtoServer"
                        :auto-upload="false"
                        :file-list="fileListServer">
                </el-upload>
            </el-dialog>
            <el-dialog
                    title="Resim Konumu"
                    :visible.sync="drawerResimKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="0" @change="changeKonum('resim','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="1" @change="changeKonum('resim','1')">
                            <img src="../../../assets/images/2.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="2" @change="changeKonum('resim','2')">
                            <img src="../../../assets/images/5.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="3" @change="changeKonum('resim','3')">
                            <img src="../../../assets/images/4.png" alt="Sol" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="4" @change="changeKonum('resim','4')">
                            <img src="../../../assets/images/3.png" alt="Üst" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Menü Konumu"
                    :visible.sync="drawerMenuKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.menuKonum" label="0" @change="changeKonum('menu','0')">
                            <img src="../../../assets/images/1.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.menuKonum" label="1" @change="changeKonum('menu','1')">
                            <img src="../../../assets/images/6.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.menuKonum" label="2" @change="changeKonum('menu','2')">
                            <img src="../../../assets/images/9.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Galeri Konumu"
                    :visible.sync="drawerGaleriKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.galeri" label="0" @change="changeKonum('galeri','0')">
                            <img src="../../../assets/images/1.png" alt="Dikey,Büyük" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.galeri" label="1" @change="changeKonum('galeri','1')">
                            <img src="../../../assets/images/7.png" alt="Dikey,Büyük" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.galeri" label="2" @change="changeKonum('galeri','2')">
                            <img src="../../../assets/images/8.png" alt="Yatay,Küçük" width="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    :title='$t("src.views.apps.rakamlar.islem.iconList")'
                    :visible.sync="iconListDialog"
                    width="60%"
                    center>
                <div>
                    <el-row class="iconRow">
                        <el-input class="margin-bottom-10" placeholder="Listede Olmayan Bir Icon Girebilirsiniz." size="medium" v-model="sayfaForm.icon"></el-input>
                        <el-col v-for="(item,index) in iconListe"
                                :key="item"
                                :label="item"
                                :value="item" :lg="4" :md="4" :sm="8" :xs="8"
                                style="border: 1px solid #9a9a9a; padding: 5px; height: 100px; text-align: center;display:table">
                            <div v-on:click="iconSelect(item)" class="iconCerceve" id="#iconCerceve">
                                <el-button type="text">
                                    <i style="font-size: 24px;text-align: center" :class="item"></i>
                                </el-button>
                                <br>
                                <span class="icon-name" :data-class="item">{{item}}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
    import draggable from 'vuedraggable'
    import EventBus from '@/components/event-bus'

    let $ = JQuery;
    import seoService from '../../../WSProvider/SeoService'
    import sayfaService from '../../../WSProvider/SayfaService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import iconJson from '../../../icon'
    import '@fortawesome/fontawesome-free/css/all.css'
    import '@fortawesome/fontawesome-free/js/all.js'

    export default {
        name: "SayfaGuncelle",
        components: {
            draggable,
        },
        watch: {
            imageListMain: function (val) {
                if (val.length === 1) {
                    this.sayfaForm.resimKonum = "1";
                    this.sayfaForm.galeriKonum = "0";
                } else if (val.length > 1) {
                    this.sayfaForm.galeriKonum = "1";
                } else {
                    this.sayfaForm.resimKonum = "0";
                    this.sayfaForm.galeriKonum = "0";
                }
            },
        },
        data() {
            return {
                checkedKeys: [],
                checked: false,
                checked2: false,

                iconListe: iconJson["v5.0.9"],
                iconListDialog: false,

                seoBaslikLimit: 0,
                seoBaslikDilLimit: 0,
                drawerResimKonum: false,
                drawerMenuKonum: false,
                drawerGaleriKonum: false,
                path: sayfaService.path,
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListServer: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                linkVisible: false,
                //Tree
                visibleUstSayfa: false,
                treeList: [],
                defaultProps: {
                    id: 'id',
                    children: 'children',
                    label: 'name'
                },
                // Form
                btnResim: "Seç",
                btnMenu: "Seç",
                btnGaleri: "Seç",
                linkChange: true,
                seoIcerikChange: true,
                seoIcerikDEChange: true,
                seoIcerikENChange: true,
                VisibleA: false,
                duzenleBtnVisible: true,
                imageListMain: [],
                fileListMain: [],
                fileListServer: [],
                updateSayfaId: [],
                updateData: [],
                orjinalResimList: [],
                ustSayfaData: {},
                updateDataDE: [],
                updateDataEN: [],
                sayfaDetayListKlon: [],
                sayfaForm: {
                    baslik: "",
                    altBaslik: "",
                    icerik: "",
                    icon: "",
                    buton: "",
                    butonLink: "",
                    video: [],
                    belge: [],
                    resim: [],
                    seoBaslik: '',
                    seoIcerik: '',
                    durum: "1",
                    link: '',
                    sayfaTuru: '0',
                    ustSayfaId: '',
                    gorunum: false,
                    resimKonum: "0",
                    menuKonum: "0",
                    galeriKonum: "0",
                    dil: {
                        de: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: '',
                            buton: '',
                            butonLink: ''
                        },
                        en: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: '',
                            buton: '',
                            butonLink: ''
                        },
                    }
                },
                rulesSayfalar: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Seçiniz",
                        trigger: 'blur'
                    }],
                    seoBaslik: [{
                        max: 70,
                        message: "Tavsiye edilen SEO Başlık limitini aştınız.",
                        trigger: 'change'
                    }],
                    seoIcerik: [{
                        max: 160,
                        message: "Tavsiye edilen SEO İçerik limitini aştınız.",
                        trigger: 'change'
                    }],
                },
                ilkEkleme: false,
            }
        },
        mounted() {
            this.updateSayfaId = this.$store.state.updateKodu;
            this.getSayfaDetay(this.updateSayfaId);
        },
        methods: {
            videoAktif(deger) {
                if (deger === true && this.ilkEkleme === false) {
                    this.haberlerForm.video.push('');
                    this.ilkEkleme = true
                } else {
                    this.haberlerForm.video = [];
                    this.ilkEkleme = false
                }
            },
            videoEkle(val, gelenind) {
                if (this.haberlerForm.video[gelenind] !== '') {
                    this.haberlerForm.video.push('');
                }
            },
            removeVideo(item) {
                this.haberlerForm.video.splice(item, 1);
            },
            seoBaslikChange(id) {
                this.seoBaslikLimit = this.sayfaForm.seoBaslik.length;
                if (this.seoBaslikLimit > 70) {
                    $('#' + id).closest('div').find('div').addClass('limitAsim');
                } else {
                    $('#' + id).closest('div').find('div').removeClass('limitAsim');
                }
            },
            iconSelect(value) {
                this.sayfaForm.icon = value;
                $("body").find(".aktifIkon").removeClass("aktifIkon")
                $(".iconRow").find('span[data-class="' + value + '"]').closest(".iconCerceve").parent("div").addClass("aktifIkon");
                notification.Status("success", this, value + " iconu seçildi.")
            },
            seoIcerikTespit() {
                if (this.seoIcerikChange && this.sayfaForm.icerik) {
                    const myStr = functions.strip_html_tags(this.sayfaForm.icerik);
                    this.sayfaForm.seoIcerik = myStr.substring(0, 140);
                } else this.sayfaForm.seoIcerik = '';
            },
            getSayfaDetay(sayfaId) {
                let self = this;
                sayfaService.sayfaDetay(sayfaId).then((response) => {
                    if (response.status === 200) {
                        self.linkVisible = true;
                        if (response.data.anaResim) {
                            self.orjinalResimList.push(response.data.anaResim);
                            self.imageListMain.push({
                                name: response.data.anaResim,
                                url: sayfaService.imageUrlOrta + response.data.anaResim
                            });
                        }
                        if (response.data['resim']) {
                            response.data['resim'].forEach(function (e) {
                                if (e) {
                                    self.orjinalResimList.push(e);
                                    self.imageListMain.push({
                                        name: e,
                                        url: sayfaService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data['video']) {
                            // this.checked2 = true;
                            // this.ilkEkleme = true;
                            response.data['video'].forEach(function (e) {
                                if (e) {
                                    self.sayfaForm.video.push(e);
                                }
                            });
                        }
                        if (response.data['belge']) {
                            response.data['belge'].forEach(function (e) {
                                if (e) {
                                    self.fileListMain.push({
                                        name: e,
                                        url: sayfaService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data['ustSayfaId']) {
                            this.sayfaForm.sayfaTuru = '1';
                            this.getTreeList('1')

                            // self.urunForm.kategori.push(response.data['ustSayfaId']);
                            self.checkedKeys.push(response.data['ustSayfaId'])


                            this.$nextTick(() => {
                                this.$refs.tree.setCheckedKeys(self.checkedKeys);
                            });


                        } else {
                            this.sayfaForm.sayfaTuru = '0';
                        }
                        this.sayfaForm.baslik = response.data.baslik;
                        this.sayfaForm.altBaslik = response.data.altBaslik;
                        if (response.data.link) {
                            this.sayfaForm.link = response.data.link;
                            this.linkVisible = true
                        }
                        if (response.data.icerik) {
                            this.sayfaForm.icerik = functions.htmlDecode(response.data.icerik);
                        }
                        // if (response.data.video) {
                        //     this.checked2 = true;
                        //     this.sayfaForm.video = functions.htmlDecode(response.data.video);
                        // }

                        if (response.data.buton || response.data.butonLink) {
                            this.checked = true;
                            this.sayfaForm.buton = response.data.buton;
                            this.sayfaForm.butonLink = response.data.butonLink;
                        }
                        this.sayfaForm.icon = response.data.icon;

                        this.sayfaForm.seoBaslik = response.data.seoBaslik;
                        this.sayfaForm.seoIcerik = response.data.seoIcerik;
                        this.sayfaForm.durum = response.data.durum;
                        this.sayfaForm.goster = response.data.goster;
                        this.sayfaForm.resimKonum = response.data.resimKonum;
                        this.sayfaForm.menuKonum = response.data.menuKonum;
                        this.sayfaForm.galeri = response.data.galeri;
                        if (response.data.dil.de) {
                            self.sayfaForm.dil.de.baslik = response.data.dil.de.baslik;
                            self.sayfaForm.dil.de.altBaslik = response.data.dil.de.altBaslik;
                            self.sayfaForm.dil.de.seoBaslik = response.data.dil.de.seoBaslik;
                            self.sayfaForm.dil.de.seoIcerik = response.data.dil.de.seoIcerik;
                            if (response.data.dil.de.icerik) {
                                self.sayfaForm.dil.de.icerik = functions.htmlDecode(response.data.dil.de.icerik);
                            }
                        }
                        if (response.data.dil.en) {
                            self.sayfaForm.dil.en.baslik = response.data.dil.en.baslik;
                            self.sayfaForm.dil.en.altBaslik = response.data.dil.en.altBaslik;
                            self.sayfaForm.dil.en.seoBaslik = response.data.dil.en.seoBaslik;
                            self.sayfaForm.dil.en.seoIcerik = response.data.dil.en.seoIcerik;
                            if (response.data.dil.en.icerik) {
                                self.sayfaForm.dil.en.icerik = functions.htmlDecode(response.data.dil.en.icerik);
                            }
                        }
                        this.sayfaDetayListKlon = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            handleNodeClick(data,dd,aa) {
                this.$refs.tree.setCheckedKeys([]);
                this.$refs.tree.setCheckedKeys([data.id]);
                this.ustSayfaData = {
                    type: "ustSayfaId",
                    value: data.id
                };
            },
            linkTespitLink() {
                let self = this;
                if (this.sayfaForm.link) {
                    seoService.linkKontrol(self.sayfaForm.link.replace("'", "").substring(0, 60)).then((response) => {
                        if (response.status === 200) {
                            self.sayfaForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.linkChange) {
                    seoService.linkKontrol(self.sayfaForm.baslik.replace("'", "").substring(0, 60)).then((response) => {
                        if (self.sayfaForm.baslik) {
                            self.sayfaForm.seoBaslik = self.sayfaForm.baslik.substring(0, 60);
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.sayfaForm.link = response.data;
                            }
                        } else if (!self.sayfaForm.baslik) {
                            self.linkVisible = false;
                            self.sayfaForm.link = '';
                            self.sayfaForm.seoBaslik = '';
                        }
                    })
                }
            },
            seoIcerikDETespit() {
                if (this.seoIcerikDEChange && this.sayfaForm.dil.de.icerik) {
                    const myStr = functions.strip_html_tags(this.sayfaForm.dil.de.icerik);
                    this.sayfaForm.dil.de.seoIcerik = myStr.substring(0, 140);
                } else this.sayfaForm.dil.de.seoIcerik = '';
            },
            seoIcerikENTespit() {
                if (this.seoIcerikENChange && this.sayfaForm.dil.en.icerik) {
                    const myStr = functions.strip_html_tags(this.sayfaForm.dil.en.icerik);
                    this.sayfaForm.dil.en.seoIcerik = myStr.substring(0, 140);
                } else this.sayfaForm.dil.en.seoIcerik = '';
            },
            getTreeList(value) {
                if (value === '1') {
                    let self = this;
                    sayfaService.sayfaTree().then((response) => {
                        this.treeList = response.data;
                        self.visibleUstSayfa = true;
                    });
                } else {
                    self.visibleUstSayfa = false;
                }
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim('sayfa').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: sayfaService.imageUrlOrta + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, "sayfa-" + functions.randomText(7) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageUploadtoServer(file) {
                let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                if (obj === undefined) {
                    var item = {
                        name: file.name,
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    updateListImage(this, 'resim', 1, file.name.slice(file.name.indexOf("-") + 1));
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    notification.Status('warning', this, 'Bu resim zaten mevcut');
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            sumResimFonk(file, imgname, item) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('sayfa', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.imageListMain.push(item);
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.sayfaForm.baslik) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "sayfa-" + functions.randomText(7) + '-' + this.sayfaForm.link + ".jpg";
                        } else {
                            imgname = "sayfa-" + functions.randomText(7) + '-' + this.sayfaForm.link + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "sayfa-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "sayfa-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                    if (obj === undefined) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.sumResimFonk(file, imgname, item);
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverDocumentList() {
                var dizi = [];
                controllerService.sunucuBelge('sayfa').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                            };
                            dizi.push(item);
                        });
                        this.fileListServer = dizi;
                    }
                })
            },
            fileUploadtoServer(file) {
                if (this.fileListMain.length === 0) {
                    var item = {
                        name: file.name,
                        url: file.url,
                    };
                    this.fileListMain.push(item);
                    updateListFile(this, 'belge', 1, file.name.slice(file.name.indexOf("-") + 1));
                    status.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' belgesi eklendi.');
                } else {
                    let obj = this.fileListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                    if (obj === undefined) {
                        item = {
                            name: file.name,
                            url: file.url,
                        };
                        this.fileListMain.push(item);
                        updateListFile(this, 'belge', 1, file.name.slice(file.name.indexOf("-") + 1));
                        status.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' belgesi eklendi.');
                    } else {
                        status.Status('warning', this, 'Bu belge zaten mevcut');
                    }
                }
            },
            fileRemove(file) {
                this.fileListMain.splice(this.fileListMain.indexOf(file), 1);
                updateListFile(this, 'belge', 0, file.name.link, file.name.belgeAdi);
            },
            fileUpload(file, fileList) {
                let self = this;
                var type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                var typeExcel = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                if (file.raw["type"] === type || file.raw["type"] === typeExcel || file.raw["type"] === 'application/vnd.ms-excel' || file.raw["type"] === 'application/msword' || file.raw["type"] === 'application/pdf') {
                    var uzanti = (file.name.slice(file.name.lastIndexOf(".")));
                    var dosyaName = (file.name.split(file.name.slice(file.name.lastIndexOf(".")))[0]).substring(0, 60);
                    var imgname = functions.randomText(7) + '-' + functions.linkTemizle(dosyaName) + uzanti;
                    var item = {
                        name: imgname,
                        url: file.url,
                        id: file.raw.lastModified
                    };
                    this.fileListMain.push(item);
                    const files = file.raw;
                    if (files) {
                        const reader = new FileReader();
                        reader.onload = e => {
                            const data = e.target.result;
                            controllerService.belgeYukle('sayfa', imgname, data).then((response) => {
                                if (response.status === 200) {
                                    updateListFile(this, 'belge', 1, response.data, dosyaName);
                                } else notification.Status(response.status, this);
                            });
                        }
                        reader.readAsDataURL(files);

                    }
                } else {
                    fileList.pop();
                    status.Status('warning', this, 'Yalnızca ".pdf", ".xls", "xlsx", ".doc" ve ".docx" uzantılı görsel seçiniz!!');
                }
            },
            sayfaGuncelle(formName) {
                let self = this;
                for (var key in this.sayfaDetayListKlon) {
                    if (key !== 'resim' && key !== 'belge' && key !== 'dil' && key !== 'ustSayfaId' && key !== 'video') {
                        if (this.sayfaDetayListKlon[key] !== this.sayfaForm[key]) {
                            if (this.sayfaForm[key] || this.sayfaForm[key] === '') {
                                var item = {
                                    type: key,
                                    value: this.sayfaForm[key]
                                };
                                this.updateData.push(item);
                            }
                        }
                    } else if (key === "resim") {
                        if (self.imageListMain.length === 0) {
                            if (self.orjinalResimList.length > 0) {
                                self.orjinalResimList.forEach(function (e) {
                                    updateListImage(self, 'resim', 0, e);
                                })
                            }
                        } else {
                            for (var i = 0; i < self.imageListMain.length; i++) {
                                if (i === 0) {
                                    if (self.imageListMain[0].name !== self.orjinalResimList[0]) {
                                        updateListImage(self, 'resim', 2, self.imageListMain[0].name);
                                        let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[0]);
                                        if (obj !== undefined) {
                                            updateListImage(self, 'resim', 1, self.orjinalResimList[0]);
                                        }
                                    }
                                } else {
                                    let obj = self.orjinalResimList.find(data => data === self.imageListMain[i].name);
                                    if (obj === undefined) {
                                        updateListImage(self, 'resim', 1, self.imageListMain[i].name);
                                    }
                                }
                            }
                            if (self.orjinalResimList.length > 0) {
                                for (var y = 1; y < self.orjinalResimList.length; y++) {
                                    let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[y]);
                                    if (obj === undefined) {
                                        updateListImage(self, 'resim', 0, self.orjinalResimList[y]);
                                    }
                                }
                            }
                        }
                    } else if (key === 'dil') {
                        for (var keyDil in this.sayfaDetayListKlon.dil.de) {
                            if (this.sayfaDetayListKlon.dil.de[keyDil] !== this.sayfaForm.dil.de[keyDil]) {
                                if (this.sayfaForm.dil.de[keyDil] || this.sayfaForm.dil.de[keyDil] === '') {
                                    var itemDe = {
                                        type: keyDil,
                                        value: this.sayfaForm.dil.de[keyDil]
                                    };
                                    this.updateDataDE.push(itemDe);
                                }
                            }
                        }
                        for (var keyDil2 in this.sayfaDetayListKlon.dil.en) {
                            if (this.sayfaDetayListKlon.dil.en[keyDil2] !== this.sayfaForm.dil.en[keyDil2]) {
                                if (this.sayfaForm.dil.en[keyDil2] || this.sayfaForm.dil.en[keyDil2] === '') {
                                    var itemEn = {
                                        type: keyDil2,
                                        value: this.sayfaForm.dil.en[keyDil2]
                                    };
                                    this.updateDataEN.push(itemEn);
                                }
                            }
                        }
                        if (this.updateDataDE.length !== 0 || this.updateDataEN.length !== 0) {
                            this.updateData.push({
                                type: "dil",
                                value: {
                                    de: this.updateDataDE,
                                    en: this.updateDataEN,
                                }
                            })
                        }
                    }
                }
                if (!_.isEmpty(this.ustSayfaData)) {
                    this.updateData.push(this.ustSayfaData)
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (valid && this.updateData.length !== 0) {
                            sayfaService.sayfaGuncelle(this.updateSayfaId, this.updateData).then((response) => {
                                if (response.status === 200) {
                                    notification.Status('success', this, 'Sayfa başarıyla guncellendi.');
                                    this.resetForm(formName);
                                    EventBus.$emit("sayfaList", true)
                                } else if (response.status === 230) {
                                    notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir sayfa zaten mevcut');
                                } else {
                                    notification.Status(response.status, this);
                                }
                            })
                        } else
                            notification.Status('warning', this, 'Değişiklik yapılmadı!');
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.imageListMain = [];
                this.fileListMain = [];
                this.sayfaForm.sayfaTuru = '0';
                this.visibleUstSayfa = false;
                this.sayfaForm.link = null;
                this.linkVisible = false;
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "sayfaguncelle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "sayfaguncelle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            changeKonum(item, konum) {
                if (item === 'resim') {
                    this.drawerResimKonum = false;
                    this.btnResim = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Resim konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Resim konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Resim konumu "Alt" olarak seçildi.');
                            break;
                        case '3' :
                            notification.Status('success', this, 'Resim konumu "Sol" olarak seçildi.');
                            break;
                        case '4' :
                            notification.Status('success', this, 'Resim konumu "Üst" olarak seçildi.');
                            break;
                    }
                } else if (item === 'menu') {
                    this.drawerMenuKonum = false;
                    this.btnMenu = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Menü konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Menü konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Menü konumu "Alt" olarak seçildi.');
                            break;
                    }
                } else if (item === 'galeri') {
                    this.drawerGaleriKonum = false;
                    this.btnGaleri = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Galeri konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Galeri konumu "Dikey,Büyük" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Galeri konumu "Yatay,Küçük" olarak seçildi.');
                            break;
                    }
                }
            }
        },
    }

    function updateListImage(self, type, durum, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                [type]: name
            }]
        };
        self.updateData.push(item);
    }

    function updateListFile(self, type, durum, link, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                link: link,
                belgeAdi: name
            }]
        };
        self.updateData.push(item);
    }
</script>

<style scoped>
    .colAyariFth {
        height: 92px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        text-align: center;
    }
</style>
